import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import BranchContext from "./../context/branch";
import DatePicker from "react-datepicker";
import Rendertruckover from "./rendertruckover";
import moment from "moment";
import ScrollToTop from "../common/ScrollToTop";
import { gettruckover } from "../../services/wms";
import Headerproduct from "./headerproduct501";
import Input from "./input";
//import DetailsCard from "./../wms/detailscard";
const Showtruckover = () => {
  const { currentBranch } = useContext(BranchContext);
  const [register, setregister] = useState([]);
  const [typeid, settypeid] = useState(0);
  const [hourid, sethourid] = useState(0);
  const [statusid, setstatusid] = useState(0);
  const [startDate, setstartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [lastupdate, setlastupdate] = useState(new Date());
  const [showonscroll, setshowonscroll] = useState(false);
  const [branchid, setbranchid] = useState(1);
  const [onprocess, setonprocess] = useState(false);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [total, settotal] = useState(0);
  const [textdriven, settextdriven] = useState();

  useEffect(() => {
    if (!currentBranch) return;
    setregister([]);
  }, [
    startDate,
    onprocess,
    endDate,
    currentBranch,
    typeid,
    pageSize,
    hourid,
    statusid,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (onprocess) return;

    setLoading(true);
    setError(false);

    const getdata = async () => {
      const { data: result } = await gettruckover(
        typeid,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        hourid,
        statusid,
        pageSize,
        pageNumber
      );
      if (result.status === "success") {
        settotal(result.data.total);
        setregister((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    getdata();
  }, [
    startDate,
    onprocess,
    endDate,
    currentBranch,
    typeid,
    pageSize,
    pageNumber,
    hourid,
    statusid,
  ]);
  //console.log("register",register)
  const handleProductChange = (event) => {
    setPageNumber(1);
    settypeid(event);
  };
  const handleovertimeChange = (event) => {
    setPageNumber(1);
    sethourid(event);
  };
  const handleStatusIdChange = (event) => {
    setPageNumber(1);
    setstatusid(event);
  };
  const handleChangStartDate = (event) => {
    setstartDate(event);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
  };
  const handleTextdrivenNamechange = ({ currentTarget: input }) => {
    //setdrivenName(input.value);
    settextdriven(input.value);
    //console.log("Name",input.value)
  };
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );
  const handleChangeonProgress = (event) => {
    setonprocess(event);
  };
  return (
    <>
    <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <div className="">
              <i>
                จากวันที่ 
              </i>

              <div className="mt-0" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>
          </div>

          <div className="col-auto">
            <div className="">
              <i>
                ถึงวันที่ 
              </i>

              <div className="mt-0" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleChangEndDate}
                />
              </div>
            </div>
          </div>
       
   

      <div className="row col-auto">
        <div className="col-auto">
          <div className="form-group">
            <Input
              name="search"
              value={textdriven}
              placeholder="ค้นหา ทะเบียนรถ"
              onChange={handleTextdrivenNamechange}
              // onKeyPress={handleKeyPress}
              // onClick={handleSearchDrinvenClick}
              search="ค้นหา"
            />
          </div>
        </div>

        <div className="col-auto">
          <div>&nbsp;</div>
          <button className="btn btn-success ">Download</button>
        </div>
      </div>
      </div>
      <div className="row">
        <div className="col-auto mx-4">
          <i>
            กลุ่มสินค้า 
          </i>

          <div className="form-group">
            <Headerproduct groupid={branchid} onChange={handleProductChange} />
          </div>
        </div>
        <div className="col-auto mx-4">
          <i>
            เงื่อนไขเวลา 
          </i>
          <div className="form-group">
            <Headerproduct groupid={3} onChange={handleovertimeChange} />
          </div>
        </div>

        <div className="col-auto mx-4">
          <i>
            สถานะ 
          </i>
          <div className="form-group">
            <Headerproduct groupid={4} onChange={handleStatusIdChange} />
          </div>
        </div>
      </div>
      
      <p className="text-success">
        แสดงข้อมูล {register ? register.length : 0} / {total} รายการ
      </p>

      <ScrollToTop />
      <Rendertruckover
        list={register}
        loading={loading}
        error={error}
        lastBookElementRef={lastBookElementRef}
        onProgress={handleChangeonProgress}
      />
      <div>{loading && "Loading..."}</div>
      <div>{error && "Error"}</div>
      </div>
    </>
  );
};

export default Showtruckover;
